module.exports = __webpack_public_path__ + "static/media/search-3.788fe47a.png";